import { useQuery } from "@tanstack/react-query";
import { getCompanyPastProjects } from "newui/features/Company/company-api";
import type { PastProject } from "newui/features/Company/types";

export const useCompanyPastProjects = (companyId: number | null) => {
	return useQuery<PastProject[]>({
		queryKey: ["company-past-projects", companyId],
		queryFn: () => getCompanyPastProjects(companyId!),
		enabled: !!companyId,
		staleTime: 5 * 60 * 1000,
	});
};
